/**
 * Available claim types
 */
export const enum ClaimType {
    /**
     * The claim type for the role.
     */
    Role = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role',
}
